/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceAgreementsClosingRequest
 */
export interface ServiceAgreementsClosingRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ServiceAgreementsClosingRequest
     */
    idList?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementsClosingRequest
     */
    contactNotes?: string;
}

/**
 * Check if a given object implements the ServiceAgreementsClosingRequest interface.
 */
export function instanceOfServiceAgreementsClosingRequest(value: object): value is ServiceAgreementsClosingRequest {
    return true;
}

export function ServiceAgreementsClosingRequestFromJSON(json: any): ServiceAgreementsClosingRequest {
    return ServiceAgreementsClosingRequestFromJSONTyped(json, false);
}

export function ServiceAgreementsClosingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceAgreementsClosingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'idList': json['idList'] == null ? undefined : json['idList'],
        'contactNotes': json['contactNotes'] == null ? undefined : json['contactNotes'],
    };
}

export function ServiceAgreementsClosingRequestToJSON(json: any): ServiceAgreementsClosingRequest {
    return ServiceAgreementsClosingRequestToJSONTyped(json, false);
}

export function ServiceAgreementsClosingRequestToJSONTyped(value?: ServiceAgreementsClosingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idList': value['idList'],
        'contactNotes': value['contactNotes'],
    };
}

